
import { Trophy } from "lucide-react";

interface HabitCardRewardProps {
  reward: string;
  rewardImage?: string;
}

export const HabitCardReward = ({ reward, rewardImage }: HabitCardRewardProps) => {
  if (!reward || reward.trim() === "") return null;
  
  return (
    <>
      <div className="flex items-center space-x-2 text-sm text-primary-dark">
        <Trophy className="w-4 h-4" />
        <span>Reward: {reward}</span>
      </div>
      
      {rewardImage && (
        <div className="mt-2 rounded-lg overflow-hidden">
          <img
            src={rewardImage}
            alt={reward}
            className="w-full h-32 object-cover transition-transform duration-300 hover:scale-105"
          />
        </div>
      )}
    </>
  );
};
